import React from 'react'
import DataTable from '../../DataTable/DataTable'
import clsx from "clsx"

export default class OrderCardBuilderSystemNotifications extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    $(window).on('refresh_data_table.SystemNotifications', () => {
      top.window.refreshSystemNotificationsBadgeNumber();
    })
  }

  componentWillUnmount() {
    $(window).off('refresh_data_table.SystemNotifications')
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'system_notifications',
      'tab-pane': true
    });
    return (
      <div className={tabClasses} id="system_notifications">
        <div className="panel panel-default">
          <div className="panel-body container">
            {!this.props.new_record
            ?
              <DataTable
              endpoint={this.props.system_notifications_data_table_path}
              no_data_text={I18n.t('none')}
              currency_unit={I18n.t('number.currency.format.unit')}
              delimiter={I18n.t('number.currency.format.delimiter')}
              separator={I18n.t('number.currency.format.separator')}
              date_format={this.props.date_format}
              time_format={this.props.time_format}
              inModal={true}/>
            :
              null
            }
          </div>
        </div>
      </div>
    );
  };
};
